<template>
    <svg
        v-if="$page.props.errors[name]"
        :class="'absolute text-red-300' + ' ' + positionCss"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.0001 8.24977V10.0831V8.24977ZM11.0001 13.7498H11.0092H11.0001ZM4.64939 17.4164H17.3507C18.7624 17.4164 19.6442 15.8884 18.9384 14.6664L12.5877 3.66644C11.8819 2.44452 10.1182 2.44452 9.41239 3.66644L3.06172 14.6664C2.35589 15.8884 3.23772 17.4164 4.64939 17.4164Z"
            stroke="currentColor"
            stroke-width="1.83333"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
<script>
export default {
    name: "form-error-warning-triangle",
    props: {
        name: {
            type: String,
            default: "",
        },
        positionCss: {
            type: String,
            default: "right-3 top-3",
        },
    },
};
</script>
